import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "InfoRequestDialog" })
export default class InfoRequestDialog extends Vue {
    public localizer: any = Localizer;
    public isVisible: boolean = false;

    @Prop() readonly language: string;
    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly message: string;
    @Prop() readonly isDialog: boolean;

    @Watch("isShow") onIsShowChanged(value: any) {
        this.setVisibility();
    }

    get isShow() {
        return this.$store.getters["infoRequestStore/isShow"]
    }

    public created() {
        this.setVisibility();
    }

    public setVisibility() {
        if (!this.isDialog) {
            this.isVisible = true;
        } else if (this.isDialog && this.isShow) {
            this.isVisible = true;
        }
        else if (this.isDialog && !this.isShow) {
            this.isVisible = false;
        }
    }

    public closeDialog() {
        this.$store.commit("infoRequestStore/setIsShow", false)
    }
}